<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="x-icon"
    :style="{ color: color }"
    aria-hidden="true"
  >
    <path d="M18 6 6 18"></path>
    <path d="M6 6l12 12"></path>
  </svg>
</template>

<script setup>
defineProps({
  size: {
    type: [String, Number],
    default: 24,
  },
  color: {
    type: String,
    default: '#db4437', // red
  },
})
</script>

<style scoped>
.x-icon {
  display: inline-block;
  vertical-align: middle;
}
</style>
